/* tslint:disable */
/* eslint-disable */
/**
 * POS API
 * Internal POS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetConfig200ResponseDataphoneConfigsInner
 */
export interface GetConfig200ResponseDataphoneConfigsInner {
    /**
     * 
     * @type {string}
     * @memberof GetConfig200ResponseDataphoneConfigsInner
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetConfig200ResponseDataphoneConfigsInner
     */
    business: string;
    /**
     * 
     * @type {string}
     * @memberof GetConfig200ResponseDataphoneConfigsInner
     */
    terminal: string;
    /**
     * 
     * @type {string}
     * @memberof GetConfig200ResponseDataphoneConfigsInner
     */
    signatureKey: string;
    /**
     * 
     * @type {string}
     * @memberof GetConfig200ResponseDataphoneConfigsInner
     */
    port: string;
    /**
     * 
     * @type {string}
     * @memberof GetConfig200ResponseDataphoneConfigsInner
     */
    version: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetConfig200ResponseDataphoneConfigsInner
     */
    name: string | null;
}

/**
 * Check if a given object implements the GetConfig200ResponseDataphoneConfigsInner interface.
 */
export function instanceOfGetConfig200ResponseDataphoneConfigsInner(value: object): value is GetConfig200ResponseDataphoneConfigsInner {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('business' in value) || value['business'] === undefined) return false;
    if (!('terminal' in value) || value['terminal'] === undefined) return false;
    if (!('signatureKey' in value) || value['signatureKey'] === undefined) return false;
    if (!('port' in value) || value['port'] === undefined) return false;
    if (!('version' in value) || value['version'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function GetConfig200ResponseDataphoneConfigsInnerFromJSON(json: any): GetConfig200ResponseDataphoneConfigsInner {
    return GetConfig200ResponseDataphoneConfigsInnerFromJSONTyped(json, false);
}

export function GetConfig200ResponseDataphoneConfigsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetConfig200ResponseDataphoneConfigsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'business': json['business'],
        'terminal': json['terminal'],
        'signatureKey': json['signatureKey'],
        'port': json['port'],
        'version': json['version'],
        'name': json['name'],
    };
}

export function GetConfig200ResponseDataphoneConfigsInnerToJSON(json: any): GetConfig200ResponseDataphoneConfigsInner {
    return GetConfig200ResponseDataphoneConfigsInnerToJSONTyped(json, false);
}

export function GetConfig200ResponseDataphoneConfigsInnerToJSONTyped(value?: GetConfig200ResponseDataphoneConfigsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'business': value['business'],
        'terminal': value['terminal'],
        'signatureKey': value['signatureKey'],
        'port': value['port'],
        'version': value['version'],
        'name': value['name'],
    };
}

